export const DEFAULT_SCOPE = 'email name';
export enum AppleAuthErrorCode {
  POPUP_CLOSED = 'popup_closed_by_user',
}
